module.exports = __webpack_public_path__ + "static/img/logo.2a41f677.png";